
































































































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public list = [
    {
      game_name: "名扬传世2003",
      game_info: "原汁原味的三职业24层炼狱，重现14级小",
    },
    {
      game_name: "飞龙传世热血版",
      game_info: "延续经典，打造勤人天堂，游戏国面以怀日写实为基调。",
    },
    {
      game_name: "轩辕传世",
      game_info: "传世特色九流派，开启传奇世界新篇章。",
    },
    {
      game_name: "久爱传世绿色版",
      game_info: "三职业复古版本，装备好暴，自由交易",
    },
    {
      game_name: "与度传世",
      game_info: "经典战神、长久耐玩、职业平衡、十年巨作",
    },
    {
      game_name: "盘游剑来传世",
      game_info: "巅峰力作，突破常规，传世新玩法。",
    },
  ];
  // public mounted() {}
}
